<template>
    <el-select v-model="selected_company_id"
               filterable
               v-bind="$attrs"
               @change="companyChange">
        <el-option v-for="company in companies"
                   :key="company.id"
                   :label="company.name"
                   :value="company.id">
            <div class="lh-1p4 py-2 px-3">
                <h6 class="mb-0">{{ company.name }}</h6>
                <small>#{{ company.id }}</small>
            </div>
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "company-selector",

        props: {
            value: {
                required: false,
            },
            is_reseller: {
                required: false,
                default: false
            },
        },

        data() {
            return {
                companies: [],
                selected_company_id: this.value
            }
        },

        mounted() {
            this.fetchCompanies()
        },

        watch: {
            value() {
                this.selected_company_id = this.value
            }
        },

        methods: {
            fetchCompanies() {
                axios.get('/api/admin/company', {
                    params: {
                        is_reseller: this.is_reseller ? 1 : 0
                    }
                }).then(res => {
                    this.companies = res.data
                })
            },

            companyChange(company_id) {
                this.$emit('change', company_id)
            }
        }
    }
</script>
